import {NumberRangeValue} from '@fl/cmsch-fe-library';

import {maxNumberIsGreater, validateMinMaxRange, validateNumberRange} from 'utils/number-range-tests';

export const validateBoundedNumberRange = (
    minimum: number, maximum: number,
) => (value: NumberRangeValue | undefined | null): string | undefined => {
    if (value === undefined || value === null) return undefined;

    const rangeError = validateNumberRange(value);
    if (rangeError) return rangeError;

    const minMaxRangeError = validateMinMaxRange(value, minimum, maximum);
    if (minMaxRangeError) return minMaxRangeError;

    const maxSmallerError = maxNumberIsGreater(value);
    if (maxSmallerError) return maxSmallerError;

    return undefined;
};
